<svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path
    d="M12.5 2.5L5.5 5.5V11.5C5.5 16.5 9.5 20.5 12.5 22.5C15.5 20.5 19.5 16.5 19.5 11.5V5.5L12.5 2.5Z"
    stroke="#080808" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
  <path
    d="M9.5 12.5L11.5 14.5L15.5 10.5"
    stroke="#080808" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
</svg>
